/**
 * 安装全局自定义的vue组件
 */
import mainFooter from "./footer.vue";
import leftMenu from "./left-menu.vue";
export default {
    install: function (Vue) {
        Vue.component("mainFooter", mainFooter);
        Vue.component("leftMenu", leftMenu);
    }
};
